import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexRating',
  setup(__props) {

const StarRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/StarRating.vue"))
const FeedbackRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/FeedbackRating.vue"))
const NumberRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/NumberRating.vue"))
const EmojiRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/EmojiRating.vue"))
const DisabledRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/DisabledRating.vue"))
const AnimationRating = defineAsyncComponent(() => import("@/components/theme/advance/rating/AnimationRating.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      mains: "Rating",
      title: "Rating"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(StarRating)),
        _createVNode(_unref(FeedbackRating)),
        _createVNode(_unref(AnimationRating)),
        _createVNode(_unref(NumberRating)),
        _createVNode(_unref(DisabledRating)),
        _createVNode(_unref(EmojiRating))
      ])
    ])
  ], 64))
}
}

})